import * as S from './styles'
import {
  convertDecimalCurrency,
  formatarParaPorcentagem
} from '../../utils/utils'
import ImgMock from '../../assets/img/relogio-thumb.png'
import { Link } from 'react-router-dom'
import { FaRegThumbsUp, FaStar } from 'react-icons/fa'

const CardProduto = ({ data, agenda, check, setCheck, onAvaliar }) => {
  return (
    <>
      <S.CardWrapper className="">
        <S.CardBox className="">
          <S.MainCard>
            {/* <img src="./" alt="produto" /> */}
            <img
              src={
                `${process.env.REACT_APP_URL_IMAGES}${data?.idMedia}` || ImgMock
              }
              alt="produto"
            />
          </S.MainCard>
          <S.CardInfo>
            <S.CardInfoTitle>{data?.name}</S.CardInfoTitle>

            {data.PossuiIPI ? (
              <S.AliquotaIPI>
                Produto Importado com alíquota de IPI de{' '}
                {formatarParaPorcentagem(data.PercentualIPI)}
              </S.AliquotaIPI>
            ) : null}

            <S.CardInfoLine>
              Vendido e Entregue por:<S.Seller>{data?.seller}</S.Seller>
            </S.CardInfoLine>

            <S.CardInfoLine>
              <div>
                <S.CardLinePrice>
                  <S.Price>{data?.preco}</S.Price>
                  {data.PossuiIPI ? (
                    <S.IPI>
                      (Com IPI de {convertDecimalCurrency(data?.ValorIPI)} já
                      incluso)
                    </S.IPI>
                  ) : (
                    ''
                  )}
                </S.CardLinePrice>
                <S.CardLinePrice>
                  <S.Quantidade>Quantidade: {data?.quantidade}</S.Quantidade>{' '}
                </S.CardLinePrice>
                {data.JaComprou && !data.Avaliado && (
                  <>
                    <S.ButtonAvaliacao onClick={onAvaliar}>
                      <S.IconStar />
                      Avalie esse produto
                    </S.ButtonAvaliacao>
                  </>
                )}

                {data.JaComprou && data.Avaliado && (
                  <S.TextAvaliacao>
                    <S.IconStar />
                    Você já avaliou esse produto. <S.IconThumb />
                  </S.TextAvaliacao>
                )}
              </div>
            </S.CardInfoLine>
          </S.CardInfo>
        </S.CardBox>
      </S.CardWrapper>
    </>
  )
}

export default CardProduto
